"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTextFieldMasked = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DmsTextField = require("./DmsTextField");
const _excluded = ["maskFunction", "placeholder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A base component for text fields with masking functionality.
 *
 * This component wraps the `DmsTextField` component and applies a masking function
 * to the input value before it is passed to the `onChange` handler.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Function} props.maskFunction - A function that takes the raw input value
 * and returns the masked value.
 * @param {string} [props.placeholder="Enter value"] - The placeholder text to display
 * in the text field.
 * @param {Function} [props.onChange] - An optional function to handle changes in the
 * input value. The masked value will be passed to this handler.
 * @param {...Object} props - Additional props are passed down to the `DmsTextField` component.
 * @returns {JSX.Element} The rendered `DmsTextField` component with applied masking.
 */
const DmsTextFieldMasked = _ref => {
  let {
      maskFunction,
      placeholder = "Enter value"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const handleChange = event => {
    const {
      value
    } = event.target;
    const maskedValue = maskFunction(value);
    event.target.value = maskedValue;
    if (props.onChange) props.onChange(event);
  };
  return /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, _extends({}, props, {
    placeholder: placeholder,
    onChange: handleChange
  }));
};
exports.DmsTextFieldMasked = DmsTextFieldMasked;
DmsTextFieldMasked.propTypes = _objectSpread({
  /**
   * Function that applies a mask to the input value.
   */
  maskFunction: _propTypes.default.func.isRequired,
  /**
   * Placeholder text displayed when the input is empty.
   */
  placeholder: _propTypes.default.string
}, _DmsTextField.DmsTextField.propTypes);